module.exports = __webpack_public_path__ + "cca70afdfc8508de2453d8feb7f71e01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/landing/optionTwo.svg
// module id = 699
// module chunks = 0